// Import model
import { ProjectSelection } from '../models/ProjectSelection';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { SelectionBin } from '../models/SelectionBin';

// Import dependency serializers (for complex types)
import { SelectionBinSerializer } from './SelectionBinSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ProjectSelection - handles JSON serialization and deserialization with type validation
 */
export class ProjectSelectionSerializer {
  /**
   * Deserializes a JSON string into a ProjectSelection instance
   */
  static deserialize(json: string): ProjectSelection {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ProjectSelection instance
   */
  static fromObject(obj: any): ProjectSelection {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ProjectSelection');
    }


    const instance: ProjectSelection = {
      itemIds: obj['itemIds'] ? (obj['itemIds'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      selectionBins: obj['selectionBins'] ? (obj['selectionBins'] as any[]).map((item: any) =>
        SelectionBinSerializer.fromObject(item)
      ) : [] as any,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      lastModifiedOn: obj['LastModifiedOn'] as string | undefined,
      parentObjectId: obj['parentObjectId'] as string | undefined,
      parentObjectIdName: obj['parentObjectId|Name'] as string | undefined,
      parentObjectType: obj['parentObjectType'] as string | undefined,
      parentObjectTypeName: obj['parentObjectType|Name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ProjectSelection instances
   */
  static deserializeArray(json: string): ProjectSelection[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ProjectSelection instance to a JSON string
   */
  static serialize(instance: ProjectSelection): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ProjectSelection instance to a plain object
   */
  static toObject(instance: ProjectSelection): any {
    return {
      'itemIds': instance.itemIds?.map((item: any) =>
        item
      ),
      'selectionBins': instance.selectionBins?.map((item: any) =>
        SelectionBinSerializer.toObject(item)
      ),
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'LastModifiedOn': instance.lastModifiedOn,
      'parentObjectId': instance.parentObjectId,
      'parentObjectId|Name': instance.parentObjectIdName,
      'parentObjectType': instance.parentObjectType,
      'parentObjectType|Name': instance.parentObjectTypeName,
    };
  }

  /**
   * Serializes an array of ProjectSelection instances to a JSON string
   */
  static serializeArray(instances: ProjectSelection[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
